// export const processingOrderChipColor = (type) => {
//   if (type === "failed") {
//     return (
//       <div
//         style={{
//           background: "rgba(248, 55, 58, 0.17)",
//           color: "#FF1818",
//           width: "100%",
//           fontSize: "12px",
//           borderRadius: "8px",
//           textAlign:"center",
//           padding: "8px",
//         }}
//         // className={styles.order_tabs}
//       >
//         Failed
//       </div>
//     );
//   }
//   if (type === "fulfilled") {
//     return (
//       <div
//         style={{
//           background: "rgba(112, 210, 40, 0.31)",
//           color: "#6FD226",
//           fontWeight: 600,
//           width: "100%",
//           fontSize: "12px",
//           borderRadius: "8px",
//           padding: "8px",
//         }}
//       >
//         Fulfilled
//       </div>
//     );
//   }
//   if (type === "pending") {
//     return (
//       <div
//         style={{
//           background: "rgba(174, 205, 255, 0.5)",
//           color: "#1890FF",
//           width: "100%",
//           fontSize: "12px",
//           borderRadius: "8px",
//           padding: "8px",
//         }}
//       >
//         Pending
//       </div>
//     );
//   }
// };
export function getOrderChipProps(value) {
  if (value === "Waiting") {
    return (
      <div
        style={{
          background: "rgba(145, 85, 253, 0.25)",
          fontSize: "12px",
          borderRadius: "8px",
          padding: "8px",
          width:"100%"
        }}
      >
        Waiting
      </div>
    );
  }
  if (value === "Pending" || value === "Rejected") {
    return (
      <div
        style={{
          background: "rgb(255, 207, 207)",
          fontSize: "12px",
          borderRadius: "8px",
          padding: "8px",
          width:"100%"
        }}
      >
        {value}
      </div>
    );
  }
  else {
    if (value === "Shipped") {
      return (
        <div
          style={{
            background: "#D4FFD3",
            fontSize: "12px",
            borderRadius: "8px",
            padding: "8px",
            width:"100%"
          }}
        >
          Shipped
        </div>
      );
    }

    if (value === "Processing" || value === "processing") {
      return (
        <div
          style={{
            background: "rgba(102, 155, 244, 0.29)",
            fontSize: "12px",
            borderRadius: "8px",
            padding: "8px",
            width:"100%"
          }}
        >
          In Process
        </div>
      );
    }
  }
}